<template>
  <div class="bodys" v-if="body_show">
    <div v-if="info.buy">
      <div v-if="!info.missionType || !info.same">
        <div class="top_my">
          <ul class="clearfix">
            <li>
              <img :src="user.headimgurl" alt="" />
            </li>
            <li>
              <span></span>
              <a>{{info.first_fee}}元<br/>红包</a>
            </li>
            <li>
              <span></span>
              <a>{{info.first_fee}}元<br/>红包</a>
            </li>
          </ul>
          <h1>每邀请1位即得 {{info.first_fee}} 元 红包</h1>
          <a class="yq" @click="card_show=true">邀请好友报名</a>
          <router-link :to="'/invitation_progress?course_id=' + course_id + '&urlfrom=index_invite_progress'" class="yqs">查看我的邀请进度>></router-link>
        </div>
      </div>
      <div v-else>
        <div v-if="info.mission">
          <div class="top_my">
            <h2>您发起的拼团将于 <span>{{time.hourTime}}</span> 时 <span>{{time.minuteTime}}</span> 分 <span>{{time.secondTime}}</span> 秒 后结束</h2>
            <ul class="clearfix">
              <li>
                <img :src="user.headimgurl" alt="" />
              </li>
              <li>
                <span></span>
                <a>好友<br/>参团</a>
              </li>
              <li>
                <span></span>
                <a>{{info.first_fee}}元<br/>红包</a>
              </li>
            </ul>
            <h1>邀请{{mission.num}}位好友即拼团成功<br/>之后每邀请1位即得{{info.first_fee}}元红包</h1>
            <a class="yq" @click="card_show=true">邀请好友来参团</a>
          </div>
        </div>
        <div v-else>
          <div class="top_my">
            <ul class="clearfix">
              <li>
                <img :src="user.headimgurl" alt="" />
              </li>
              <li>
                <span></span>
                <a>{{info.first_fee}}元<br/>红包</a>
              </li>
              <li>
                <span></span>
                <a>{{info.first_fee}}元<br/>红包</a>
              </li>
            </ul>
            <h1>每邀请1位即得 {{info.first_fee}} 元 红包</h1>
            <a class="yq" @click="card_show=true">邀请好友报名</a>
            <router-link :to="'/invitation_progress?course_id=' + course_id + '&urlfrom=index_invite_progress'" class="yqs">查看我的邀请进度>></router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="info.mission">
        <div class="top_v clearfix">
          <img :src="mission.shareimg" alt="" />
          <div class="v_r">
            <h2>{{mission.sharename}}</h2>
            <h3>邀请你和我一起做同学，并为你节省{{(info.price*100-info.missionPrice*100)/100}}元学费！</h3>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="top_v clearfix">
          <img :src="mission.shareimg" alt="" />
          <div class="v_r">
            <h3>{{mission.sharename}} 已入营</h3>
            <h2>邀请你也来发起拼团，限时优惠中</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="top">
      <img :src="info.cover" alt="" class="top_m" />
      <span>{{info.count}} 人已购买</span>
      <!-- <div class="top_b clearfix">
        <div class="tb_l">
          <h2>课程原价 {{info.price}} 元</h2>
          <h3>限时拼团优惠价 {{info.missionPrice}} 元</h3>
          <h4>{{info.count}}人已购买</h4>
        </div>
        <div class="tb_r">
          <router-link :to="'/invitation_progress?course_id=' + course_id + '&urlfrom=' + shimo_url">
            <div class="red-envelope">
              <div class="red-envelope-text">
                <small class="red-num">{{info.first_fee}}</small>元
              </div>
            </div>
            <span>我要<br/>推广</span>
          </router-link>
        </div>
      </div> -->
    </div>
    <div class="content">
        <div  :class="['tar_img',!info.same?'tar_imgs':'']" v-html="info.detail"></div>
        <!-- 7天的职业定位训练营原价199元，拼团仅需9.9元-->
        <h3 class="on-money">{{info.name}}<br/>原价{{info.price}}元，<span>拼团仅需{{info.missionPrice}}元</span></h3>
    </div>
    <!-- <div  :class="['tar_img',!info.same?'tar_imgs':'']" v-html="info.detail"> -->
      <!-- <img src="@a/training1.png" alt="" />
      <img src="@a/training2.png" alt="" />
      <img src="@a/training3.png" alt="" />
      <img src="@a/training4.png" alt="" />
      <img src="@a/training5.png" alt="" />
      <img src="@a/training6.png" alt="" />
      <img src="@a/training7.png" alt="" />
      <img src="@a/training8.png" alt="" />
      <img src="@a/training9.png" alt="" />
      <img src="@a/training10.png" alt="" />
      <img src="@a/training11.png" alt="" />
      <img src="@a/training12.png" alt="" />
      <img src="@a/training13.png" alt="" />
      <img src="@a/training14.png" alt="" /> -->
    <!-- </div> -->
    <!-- 学习须知 -->
    <div class="learning-instructions">
      <h3>学习须知</h3>
      <div class="instructions-content">
        <p>1. 拼团成功后或通过好友邀请报名，即可查看班主任微信</p>
        <p>2. 申请添加班主任会在48小时内通过，请耐心等待哦。</p>
        <p>3. 报名后班主任会跟进排期安排最近期次入学。</p>
      </div>
    </div>
    <!--  -->
    <div class="banq">
      * 本训练营由新精英生涯（北京）教育科技有限公司版权所有，违者必究
    </div>
    <div v-if="info.buy">
      <div class="foot clearfix">
        <div class="foot_l foot_ls">
          <router-link :to="'/invitation_progress?course_id='+ course_id + '&urlfrom=' + shimo_url_group">
            我要推广
          </router-link>
        </div>
        <div class="foot_r foot_rs">
          <router-link :to="info.mission?'/details_spell?course_id='+ course_id + '&share='+ share:'/teacher_code?course_id='+ course_id">
            查看班主任微信
          </router-link>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="foot clearfix" v-if="info.mission">
        <div class="foot_l foot_lss">
          现在报名
          <br/> 享受拼团抢购价 <span>¥{{info.missionPrice}}</span>
        </div>
        <div class="foot_r foot_rs" @click="signHandle('mission',2)">
          立即参团
        </div>
      </div>
      <div class="foot clearfix" v-else>
        <a class="foot_l" @click="signHandle('common',0)">
          单独购买
          <br/>¥{{info.price}}
        </a>
        <div class="foot_r">
          <router-link :to="'/details_spell?course_id='+ course_id + '&share='+ share + '&source=' + source + '&urlfrom=index_close_group'">
            发起拼团
            <br/>¥{{info.missionPrice}}
          </router-link>
        </div>
      </div>
    </div>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <public-mobile ref="handle" :train_pay="train_pay"></public-mobile>
  </div>
</template>
<script>
import {
  joinMission
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        course_id: '',
        share: '',
        source: '',
        info: {},
        user: {},
        mission: {},
        train_pay: {},
        type_obj: {},
        time: {},
        card_show: false,
        shimo_url: "",
        shimo_url_group: 'index_invite_progress'
      };
    },
    methods: {
      // 付款
      signHandle(type, mission_type) {
        this.train_pay = {
          share: this.share || '', //分享人ID
          source: this.source || '', //分享来源
          mission_id: this.info.mission_id, //拼团ID
          mission_type: mission_type, //拼团状态0单独购买1创建拼团2参团
          type: type,
          course_id: this.course_id
        };
        setTimeout(() => {
          this.$refs.handle.pay_training();
        }, 200)

      },
      pullData() {
        this.course_id = this.$route.query.course_id;
        this.share = this.$route.query.share;
        this.mission_id = this.$route.query.mission_id;
        if(this.$route.query.source) {
          this.source = typeof this.$route.query.source == 'string' ? this.$route.query.source:this.$route.query.source[0];
        }
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        joinMission({
            course_id: this.course_id,
            share: this.share,
            mission_id: this.mission_id
          })
          .then(data => {
            this.body_show = true;
            this.$toast.clear();
            document.title = data.info.name;
            this.info = data.info;
            this.user = data.user;
            this.mission = data.mission;
            if (this.info.same) {
              if (this.info.mission) {
                this.shimo_url = 'index_group_red';
                this.shimo_url_group = 'index_group_cash';
              } else {
                this.shimo_url = 'index_invite_red';
                this.shimo_url_group = 'index_invite_cash';
              }
            } else {
              if (this.info.mission) {
                this.shimo_url = 'index_unclose_red';
              } else {
                this.shimo_url = 'index_close_red';
              }
            }

            if (this.info.mission && this.info.same) {
              this.timeTostring();
            }
            this.type_obj = {
              nickname: data.user.nickname,
              train_name: data.info.name,
              train_id: data.info.id,
              share: data.user.id
            };
            shareCon("training", this, this.type_obj);
          });
      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.mission.surplusTime > 0) {
          this.sin = setInterval(() => {
            let result = {
              secondTime: 0,
              minuteTime: 0,
              hourTime: 0
            };
            result.secondTime = parseInt(this.mission.surplusTime); // 秒
            result.minuteTime = 0; // 分
            result.hourTime = 0; // 小时
            if (result.secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              result.minuteTime = parseInt(result.secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              result.secondTime = parseInt(result.secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (result.minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                result.hourTime = parseInt(result.minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                result.minuteTime = parseInt(result.minuteTime % 60);
              }
            }

            result.secondTime = ((result.secondTime < 10) ? "0" : "") + parseInt(result.secondTime);

            if (result.minuteTime > 0) {
              result.minuteTime = ((result.minuteTime < 10) ? "0" : "") + parseInt(result.minuteTime);
            }
            if (result.hourTime > 0) {
              result.hourTime = ((result.hourTime < 10) ? "0" : "") + parseInt(result.hourTime);
            }
            this.time = result;
            this.mission.surplusTime -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }
      }
    },
    created() {
      this.pullData();
    },
    destroyed() {
      clearInterval(this.sin)
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  // background-color: #2d1a44;
  text-align: center;
  padding-bottom: changeRem(2) + px
}

.top {
  width: 100%;
  // height: 600px;
  // background: url(../../../assets/top_b.png) top center;
  position: relative;
  span {
    position: absolute;
    right: 0;
    bottom: 32px;
    font-size: 24px;
    padding: 8px 26px 8px 16px;
    border-radius: 19px 0px 0px 19px;
    background-color: #eb5032;
    color: #ffffff;
    display: block;
  }
  img.top_m {
    width: 100%;
  }
  // .top_b {
  //   margin: 0 auto;
  //   bottom: 0;
  //   left: 30px;
  //   position: absolute;
  //   width: 690px;
  //   padding: 26px 30px;
  //   background: rgba(255, 255, 255, 1);
  //   border-radius: 8px;
  //   .tb_l {
  //     float: left;
  //     text-align: left;
  //     h2 {
  //       color: #333;
  //       font-size: 26px;
  //       line-height: 24px;
  //     }
  //     h3 {
  //       background: rgba(255, 255, 255, 1);
  //       border: 2px solid rgba(235, 80, 50, 1);
  //       padding: 2px 10px;
  //       font-size: 30px;
  //       color: #EB5032;
  //       margin-top: 10px;
  //       border-radius: 8px;
  //     }
  //     h4 {
  //       margin-top: 10px;
  //       color: #666;
  //       font-size: 24px;
  //       line-height: 22px;
  //     }
  //   }
  //   .tb_r {
  //     float: right;
  //     display: flex;
  //     .red-envelope{
  //       float: left;
  //       width: 90px;
  //       height: 116px;
  //       color: #ffffff;
  //       background: url('../../../assets/t_money.png') center no-repeat;
  //       background-size: 100% 100%;
  //       margin-right: 14px;
  //       position: relative;
  //       .red-envelope-text{
  //         position: absolute;
  //         left: 50%;
  //         transform: translateX(-50%);
  //         bottom: 18px;
  //         line-height: 1;
  //         color: #ffffff;
  //         font-size: 30px;
  //         .red-num{
  //           font-size: 50px;
  //           color: #ffffff;
  //           margin-right: 2px;
  //         }
  //       }
  //     }
  //     span {
  //       line-height: 35px;
  //       color: #EB5032;
  //       font-size: 30px;
  //       float: right;
  //       margin-top: 26px;
  //     }
  //   }
  // }
}

.top_v {
  padding: 14px 30px;
  color: #333;
  font-size: 32px;
  text-align: left;
  font-weight: bold;
  position: relative;
  background-color: #f0f0f0;
  img {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 30px;
  }
  .v_r {
    display: inline-block;
    width: 590px;
    float: right;
    h2 {
      color: #333;
      font-size: 32px;
      text-align: left;
      font-weight: bold;
    }
    h3 {
      color: #333;
      font-size: 26px;
    }
  }
}

.foot {
  height: 98px;
  font-size: 34px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  width: 100%;
  max-width: 750px;
  line-height: 40px;
  text-align: center;
  .foot_l {
    display: block;
    width: 214px;
    background-color: #fff;
    float: left;
    color: #EB5032;
    height: 100%;
    padding-top: 10px;
  }
  .foot_r {
    width: 536px;
    background-color: #EB5032;
    float: right;
    color: #fff;
    height: 100%;
    padding-top: 12px;
  }
  .foot_ls,
  .foot_rs {
    line-height: 98px;
    padding-top: 0;
    width: 50%;
    color: #fff;
    background-color: #EB5032;
  }
  .foot_ls {
    border-right: 2px solid #fff;
  }
  .foot_lss {
    font-size: 28px;
    color: #333;
    width: 50%;
    text-align: left;
    padding-left: 40px;
    span {
      color: #EB5032;
    }
  }
  a {
    color: #fff
  }
}

.top_my {
  background-color: #f0f0f0;
  padding: 30px 0;
  h2 {
    color: #333;
    font-size: 28px;
    span {
      display: inline-block;
      width: 52px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      background: rgba(235, 80, 50, 1);
      border-radius: 4px;
      color: #fff;
      font-size: 30px;
    }
  }
  ul {
    margin: 0 auto;
    margin-top: 20px;
    width: 420px;
    li {
      float: left;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
      span {
        display: inline-block;
        width: 104px;
        border-bottom: 2px dashed rgba(153, 153, 153, 1);
        vertical-align: middle;
      }
      a {
        display: inline-block;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background-color: #fff;
        color: #999;
        font-size: 20px;
        line-height: 24px;
        padding-top: 10px;
        text-align: center;
        vertical-align: middle;
      }
    }
  }
  h1 {
    margin-top: 20px;
    line-height: 40px;
    font-size: 30px;
    color: #333;
  }
  a.yq {
    width: 420px;
    height: 68px;
    line-height: 68px;
    background: rgba(235, 80, 50, 1);
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 20px;
    font-size: 30px;
    color: #fff;
    display: block;
    margin-bottom: 10px;
  }
  .yqs {
    font-size: 28px;
    color: #666
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
.banq {
  font-size: 26px;
  // color: #fff;
  color: #333333;
  width: 100%;
  padding: 20px;
  text-align: justify;
  margin: 20px 0;
}
.content{
  position: relative;
  .on-money{
      display: block;
      width: 100%;
      padding: 0 134px;
      box-sizing: border-box;
      position: absolute;
      text-align: center;
      bottom: 84px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 36px;
      color: #333333;
      span{
          color: #EB5032;
      }
  }
}
.learning-instructions {
  margin: 30px 26px 0;
  padding: 32px 50px 70px;
  background-color: #ffffff;
  h3 {
    display: block;
    margin: 0 auto;
    text-align: center;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 65px;
    background-color: #f5b417;
    color: #333333;
    border-radius: 8px 8px 0px 0px;
  }
  .instructions-content {
    padding: 30px 20px;
    p {
      text-align: left;
      font-size: 26px;
      color: #333333;
      line-height: 39px;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.tar_img{
  font-size: 0;
}
.tar_img img {
  width: 100%;
}
.tar_imgs img{
  vertical-align: middle;
}
</style>